import React from "react";
import moment from "moment";

import { OverflowTooltip } from "components";

import styles from "../matchReport.module.scss";

const dateColumn = ({ title }) => ({
	Header: title,
	accessor: "date",
	classNameHeader: `${styles.tableHeader}`,
	Cell({ value }) {
		const date = moment(value).format("DD MMMM yyyy");
		const dateResult = date === "Invalid date" ? "" : date;

		return (
			<OverflowTooltip onlyOnLaptop title={dateResult}>
				{dateResult}
			</OverflowTooltip>
		);
	},
});

export default dateColumn;
